import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Advert } from '@chegg-wt/core/components/Advert'
import HeaderWithCards from '@chegg-wt/core/components/HeaderWithCards'
import PlusTab from '@chegg-wt/core/components/PlusTab'
import Resources from '@chegg-wt/core/components/Resources'
import ErrorContainer from '@chegg-wt/core/components/ErrorContainer'
import { LvpMarginWrapper } from '@chegg-wt/core/components/Layouts/LargeVideoPlayerLayout'
import HomepageUploadWidget from '@chegg-wt/core/components/HomepageUploadWidget'
import { PRICING_TABLE_FREE } from '@chegg-wt/core/constants/pricingTable'
import { isProSelector, loggedInSelector } from '@chegg-wt/core/state/user/selectors'
import { AppState } from '@chegg-wt/core/state'
import { connect, useSelector } from 'react-redux'
import { UpgradePromotionBoxCopy } from '@chegg-wt/core/types/copy'
import {
  Resource,
  HomeCopy,
  PlusTabs,
  PricingTable as PricingTableType,
} from '@chegg-wt/core/types/core'
import usePriceTest from '@chegg-wt/core/hooks/usePriceTest'
import { useShowDiscountModal } from '@chegg-wt/core/hooks/useShowDiscountModal'
import HomePricingTable from './HomePricingTable'
import { MainWrapper } from './styled'

const PageContents = styled.div`
  background-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor20};
`
const C1Ad = styled(Advert)`
  padding-top: 16px;
  padding-bottom: 42px;
`

interface HomeProps {
  copy: {
    plusTabs: PlusTabs
    oldPricingTableData: PricingTableType
    newPricingTableData: PricingTableType
    resources: Resource[]
    cards?: HomeCopy
    resourceTitle: string
    upgradePromotionCopy?: UpgradePromotionBoxCopy
  }
  isLoggedIn: boolean
}

interface HomeTopProps {
  cards: HomeCopy
}

export const HomeTop: React.FC<HomeTopProps> = ({ cards }) => (
  <MainWrapper>
    <HeaderWithCards copy={cards} />
  </MainWrapper>
)

const Home: React.FC<HomeProps> = ({ copy, isLoggedIn }) => {
  useShowDiscountModal()

  const {
    pricingExperimentEnabled,
    pricingExperimentReady,
    discountPercentage,
  } = usePriceTest()

  const isProUser = useSelector(isProSelector)

  const [showPricingTableFirst, setshowPricingTableFirst] = useState(false)
  useEffect(() => {
    if (pricingExperimentReady && pricingExperimentEnabled) {
      if (discountPercentage) {
        setshowPricingTableFirst(true)
      }
    }
  }, [pricingExperimentReady, pricingExperimentEnabled])

  return (
    <PageContents>
      <ErrorContainer />
      <LvpMarginWrapper>
        <C1Ad placement="C1" />
      </LvpMarginWrapper>
      {!isProUser &&
        showPricingTableFirst &&
        copy.oldPricingTableData &&
        copy.newPricingTableData && (
          <HomePricingTable
            pricingTableData={copy.newPricingTableData}
            currentProductId={isLoggedIn ? PRICING_TABLE_FREE : null}
          />
        )}
      <HomepageUploadWidget />
      <PlusTab copy={copy.plusTabs} />
      {/* TODO: remove the condition below when we enable G&P on CTFM */}
      {!isProUser &&
        !showPricingTableFirst &&
        copy.oldPricingTableData &&
        copy.newPricingTableData && (
          <HomePricingTable
            pricingTableData={copy.newPricingTableData}
            currentProductId={isLoggedIn ? PRICING_TABLE_FREE : null}
          />
        )}
      <Resources
        copy={copy.resources}
        title={copy.resourceTitle}
        upgradePromotionCopy={copy.upgradePromotionCopy}
      />
    </PageContents>
  )
}

const mapStateToProps = (state: AppState) => ({
  isLoggedIn: loggedInSelector(state),
})

export default connect(mapStateToProps)(Home)
